import React from "react";
import {Show, SimpleShowLayout, TextField, BooleanField, DateField} from 'react-admin';

const UserShow = (props: any) => {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" label="User ID"/>

                <TextField source="email" label="Email"/>

                <TextField source="userType" label="Tipologia"/>

                <TextField source="mobileNumber" label="Telefono"/>

                <BooleanField source="isVerified" label="Verificato"/>

                <DateField source="emailVerifiedAt" label="Data verifica email"/>

                {/*<TextField source="rememberToken" label="Token riconoscimento"/>*/}

                {/*<TextField source="verificationCode" label="Codice di verifica"/>*/}
            </SimpleShowLayout>
        </Show>
    );
};

export default UserShow;
